import $ from 'jquery';
import renderCategoryTree from './templates/category-tree.tpl.html';


class CategoryTreeRenderer {

	observer = null;

	isRendered = false;

	constructor( containerEl ) {
		this.containerEl = containerEl;

		this.setup()
	}

	setup() {
		// Render on Mouseenter.
		this.containerEl.addEventListener( 'mouseenter', () => this.render() );

		if ( 'IntersectionObserver' in window ) {
			const options = {
				rootMargin: "0px",
				threshold: 0.1
			};

			this.observer = new window.IntersectionObserver( ( entries ) => {
				entries.forEach( entry => {
					if ( entry.isIntersecting ) {
						this.render();
					}
				} )
			}, options );
			this.observer.observe( this.containerEl );
		}
	}

	disconnect() {
		// Remove Event Listener.
		this.containerEl.removeEventListener( 'mouseenter', () => this.render() );

		if ( this.observer ) {
			this.observer.disconnect();
			this.observer = null;
		}
	}

	render() {

		// Only render once per Element.
		if ( this.isRendered ) {
			return;
		}

		const data = {
			'category': {
				'children': window.treeJSON,
			},
			'renderSelf': renderCategoryTree,
			'isOpen': false,
		};

		const result = renderCategoryTree( data );
		document.getElementById( '_lazyCategory' ).innerHTML = result;

		// Got rendered successfully.
		this.isRendered = true;
		this.disconnect();
	}
}

$( document ).ready( function() {
	const containerEl = document.getElementById( 'category_filter' );

	if ( containerEl ) {
		containerEl.ACL_TREE_RENDERER ??= new CategoryTreeRenderer( containerEl );
	}
} );


export default CategoryTreeRenderer;
